import React from "react";

const DARK_BARS  = "/logo/logo-light.png";
const LIGHT_BARS = "/logo/logo-dark.png";

export default function Logo({ size = 32, variant = "auto", className = "" }) {
  const src = variant === "light" ? LIGHT_BARS : DARK_BARS;
  return <img src={src} width={size} height={size} alt="Crescendo" className={className} />;
}

export function MinimalLogo({ size = 32, className = "" }) {
  return <Logo size={size} className={className} />;
}

/**
 * BarsLogo — animated 3-bar loading indicator.
 *
 * Implemented as HTML divs (not SVG) so border-radius is always applied
 * to the live top edge of each bar — no clip-path math, no sudden corner pop.
 *
 * Bar 1 = PEAK at t=0, Bar 3 = TROUGH at t=0 (wave flows right-to-left).
 */
export function BarsLogo({ size = 48, color = "currentColor", animated = true, className = "" }) {
  const bars = [
    { delay: "-1.0s" },  // PEAK
    { delay: "-0.5s" },  // MID
    { delay: "0s"    },  // TROUGH
  ];

  const minPct = 18;   // % of container height at trough
  const maxPct = 100;  // % of container height at peak
  const radius = Math.round(size * 0.12); // ~border-radius in px

  const style = `
    @keyframes cresc-bar {
      0%, 100% { height: ${minPct}%; border-radius: ${radius}px; }
      50%       { height: ${maxPct}%; border-radius: ${radius}px; }
    }
  `;

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "flex-end",
        gap: Math.round(size * 0.1),
        width: size,
        height: size,
      }}
      aria-hidden="true"
    >
      <style>{style}</style>
      {bars.map((b, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            background: color,
            borderRadius: radius,
            height: animated ? undefined : `${maxPct}%`,
            animation: animated
              ? `cresc-bar 2.4s ${b.delay} cubic-bezier(0.37,0,0.63,1) infinite`
              : undefined,
          }}
        />
      ))}
    </div>
  );
}
